const LEFT = "left";
const UP = "up";
const DOWN = "down";
const RIGHT = "right";

const VIS = 30;
const BASE_SPEED = 160;

export default class Player extends Phaser.Sprite {

    constructor(x, y) {
        super(game, x, y, "hero", "hero_id.png");
        this.anchor.set(0.5, 1);
        game.physics.arcade.enableBody(this);
        this.debug = true;
        this.body.setSize(15, 10, 3, 30);
        this.direction = LEFT;
        this.holding = null;
        this.movingMs = 0;

        this.shadow = game.add.sprite(0, 3, "actors", "shadow.png");
        this.addChild(this.shadow);
        this.shadow.anchor.set(0.5, 1);

        this.createAnimations()


        this.visibilityRectangle = new Phaser.Rectangle(0, 0, 0, 0);
        this.updateVisibility();

        this._speed = BASE_SPEED;
        this._speedFactors = [];
    }

    createAnimations() {
        const frameRate = 16;
        this.animations.add('walk_down', [
            "hero_wd01.png", "hero_wd02.png", "hero_wd03.png", "hero_wd05.png", "hero_wd04.png", "hero_wd05.png", "hero_wd03.png", "hero_wd02.png",
        ], frameRate, true);
        this.animations.add('walk_down_loaded', [
            "hero_wdl01.png", "hero_wdl02.png", "hero_wdl03.png", "hero_wdl05.png", "hero_wdl04.png", "hero_wdl05.png", "hero_wdl03.png", "hero_wdl02.png",
        ], frameRate, true);
        this.animations.add('walk_up', [
            "hero_wu01.png", "hero_wu02.png", "hero_wu03.png", "hero_wu05.png", "hero_wu04.png", "hero_wu05.png", "hero_wu03.png", "hero_wu02.png",
        ], frameRate, true);
        this.animations.add('walk_up_loaded', [
            "hero_wul01.png", "hero_wul02.png", "hero_wul03.png", "hero_wul05.png", "hero_wul04.png", "hero_wul05.png", "hero_wul03.png", "hero_wul02.png",
        ], frameRate, true);
        this.animations.add('walk_side', Phaser.Animation.generateFrameNames("hero_ws", 1, 6, ".png", 2), frameRate, true);
        this.animations.add('walk_side_loaded', Phaser.Animation.generateFrameNames("hero_wsl", 1, 6, ".png", 2), frameRate, true);
    }

    takeOffPants() {
        this.loadTexture('hero_pantless', 'hero_id.png')
        this.createAnimations();
    }


    _renderWebGL(renderSession, matrix) {
        // if the sprite is not visible or the alpha is 0 then no need to render this element
        if (!this.visible || this.alpha <= 0 || !this.renderable) return;

        //  They provided an alternative rendering matrix, so use it
        var wt = this.worldTransform;
        if (matrix)
        {
            wt = matrix;
        }

        //  Render children!
        for (var i = 0; i < this.children.length; i++)
        {
            this.children[i]._renderWebGL(renderSession, wt);
        }
        renderSession.spriteBatch.render(this);

    }

    updateVisibility() {
        switch (this.direction) {
            case 'left':
                this.visibilityRectangle.x = this.body.x - VIS;
                this.visibilityRectangle.y = this.body.y - VIS * 0.5;
                this.visibilityRectangle.width = VIS + Math.abs(this.width);
                this.visibilityRectangle.height = Math.abs(this.height);
                break;
            case 'right':
                this.visibilityRectangle.x = this.body.x;
                this.visibilityRectangle.y = this.body.y - VIS * 0.5;
                this.visibilityRectangle.width = VIS + Math.abs(this.width);
                this.visibilityRectangle.height = Math.abs(this.height);
                break;
            case 'up':
                this.visibilityRectangle.x = this.body.x - Math.abs(this.width) * 0.2;
                this.visibilityRectangle.y = this.body.y - VIS * 1.5;
                this.visibilityRectangle.width = Math.abs(this.width);
                this.visibilityRectangle.height = VIS + Math.abs(this.height);
                break;
            case 'down':
                this.visibilityRectangle.x = this.body.x - Math.abs(this.width) * 0.2;
                this.visibilityRectangle.y = this.body.y;
                this.visibilityRectangle.width = Math.abs(this.width);
                this.visibilityRectangle.height = VIS + Math.abs(this.height);
                break;
        }
    }

    distanceTo(object) {
        return Phaser.Point.distance({ x: this.centerX, y: this.centerY }, { x: object.centerX, y: object.centerY });
    }


    updateInputs(wasd) {
        this.body.velocity.set(0, 0);
        let oldDirection = this.direction;
        if (wasd.up.isDown) {
            this.body.velocity.y = -this.speed;
            this.direction = UP;
            this.playWalkAnimation();
        } else if (wasd.down.isDown) {
            this.body.velocity.y = this.speed;
            this.direction = DOWN;
            this.playWalkAnimation();
        } else if (wasd.left.isDown) {
            this.body.velocity.x = -this.speed;
            this.direction = LEFT;
            this.playWalkAnimation();
        } else if (wasd.right.isDown) {
            this.body.velocity.x = this.speed;
            this.direction = RIGHT;
            this.playWalkAnimation();
        } else {
            this.playIdleAnimation()
        }
        if (this.moving && oldDirection !== this.direction) {
            this.playWalkAnimation(true);
        }
    }

    hold(object) {
        if (object.constructor.type === 'hammer' && game.gameState.badKarma) {
            game.gameState.addLog('You try to pick the hammer, but it is too heavy');
            return;
        }
        this.holding = object;
        this.playIdleAnimation();
        object.setHolded();
    }

    playIdleAnimation() {
        if (this.animations.currentAnim) {
            this.animations.currentAnim = null;
            let lPrefix = this.holding ? "l" : "";
            switch (this.direction) {
                case 'left':
                    this.scale.x = 1;
                    this.frameName = 'hero_is' + lPrefix + '.png';
                    break;
                case 'right':
                    this.scale.x = -1;
                    this.frameName = 'hero_is' + lPrefix + '.png';
                    break;
                case 'up':
                    this.frameName = 'hero_iu' + lPrefix + '.png';
                    break;
                case 'down':
                    this.frameName = 'hero_id' + lPrefix + '.png';
                    break;
            }
        }
        this.moving = false;
    }

    playWalkAnimation(force) {
        if (!this.moving || force) {
            let lPrefix = this.holding ? "_loaded" : "";
            switch (this.direction) {
                case 'left':
                    this.scale.x = 1;
                    this.animations.play('walk_side' + lPrefix);
                    break;
                case 'right':
                    this.scale.x = -1;
                    this.animations.play('walk_side' + lPrefix);
                    break;
                case 'up':
                    this.animations.play('walk_up' + lPrefix);
                    break;
                case 'down':
                    this.animations.play('walk_down' + lPrefix);
                    break;
            }
            this.moving = true;
        }
    }

    drop() {
        if (this.holding.constructor.type === 'table' && !game.gameState.eventsResults.tableThrown) {
            game.gameState.eventsResults.tableThrown = true;
            console.log("(╯°□°）╯︵ ┻━┻");//todo: wanted to put to log, but there is no such chars
        }
        this.holding.setThrown(this.direction, this.body.speed + 100, this.height / 2);
        this.holding = undefined;
    }

    update() {
        this.updateVisibility();
        this.updateHolding();
        if (this.body.speed > 0) {
            this.movingMs += game.time.elapsedMs;
        } else {
            this.movingMs = 0;
        }
    }

    stop() {
        this.body.velocity.set(0, 0);
        this.playIdleAnimation();
    }

    updateHolding() {
        if (!this.holding) return;
        this.holding.x = this.x;
        this.holding.y = this.y;
        switch (this.direction) {
            case 'left':
                this.holding.x -= this.holding.width - (this.holding.x - this.holding.left) + 6;
                this.holding.y -= this.height / 2;
                break;
            case 'right':
                this.holding.x += (this.holding.x - this.holding.left) + 6;
                this.holding.y -= this.height / 2;
                break;
            case 'up':
                this.holding.y -= this.holding.height * 1.2;
                break;
            case 'down':
                this.holding.y += this.holding.height * 0.2;
                break;
        }
    }

    addFactor(factor) {
        this._speedFactors.push({factor});
    }

    get holdingFactor() {
        return this.holding ? 0.5 : 1;
    }

    get speed() {
        let s = this._speed;
        for (let {factor} of this._speedFactors) {
            s *= factor;
        }
        s *= this.holdingFactor;
        return s;
    }

    set speed(v) {
        throw new Error("never use this! use addFactor");
    }

}


// WEBPACK FOOTER //
// ./src/objects/player.js